<biz2x-loader></biz2x-loader>
<router-outlet></router-outlet>